import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { PortPayload, PortResponse } from "@/types/interface/port";

async function createPort(payload: PortPayload) {
  return await http.post<APIResponse<PortResponse>>("port/create", payload);
}

async function updatePort(idUnit = '', payload: PortPayload) {
  return await http.patch<APIResponse<PortResponse>>(`port/update?id=${idUnit}`, payload);
}

async function getPort(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<PortResponse>>(`port?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findPort(idUnit = "") {
  return await http.get<APIResponse<PortResponse>>(`port/detail?id=${idUnit}`);
}

async function deletePort(idUnit = "") {
  return await http.delete<APIResponse<PortResponse>>(`port/delete?id=${idUnit}`);
}

export default {
  createPort,
  updatePort,
  getPort,
  findPort,
  deletePort
};